// extracted by mini-css-extract-plugin
export default {"demoWebContainer":"DemoWeb_demoWebContainer__4RBrp","videoContainer":"DemoWeb_videoContainer__yBLX2"};